import React from "react";
import { Navigate } from "react-router-dom";
import { useUserData } from "../../../hooks/useUserData";
import IsfCommandCenter from "./IsfCommandCenter";
import { canViewIsfDashboard } from "./isfPermissionUtils";

/** eISF dashboard (v2 layout, readiness API). */
const ISFDashboard = () => {
  const { userData, loading: userLoading } = useUserData();

  const canView = userData && canViewIsfDashboard(userData);

  if (userLoading || !userData) {
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  if (!canView) return <Navigate to="/notification-center" replace />;

  return <IsfCommandCenter />;
};

export default ISFDashboard;
